import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { ExternalDashboardNotificationsDTO } from './getDashboardNotifications';

const saveDashboardNotificationsForListing = async ({
  dashboardId,
  listingId,
  ...data
}: ExternalDashboardNotificationsDTO & {
  dashboardId: string;
  listingId: string;
}) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/listing/${listingId}/notifications`,
    method: 'post',
    data,
  };

  await axios.request(config);
};

export default saveDashboardNotificationsForListing;
